import { Button } from "@/components/ui/button";
import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

const mockTests = [
  { name: "SELT", src: "./image/mock/selt-ukvi.png", link: "/selt" },
  { name: "IELTS", src: "./image/mock/idp-ielts.png", link: "/ielts" },
  { name: "TOEFL", src: "./image/mock/ets-toefl.png", link: "/toefl" },
  { name: "PTE", src: "./image/mock/pte.png", link: "/pte" },
  { name: "SAT", src: "./image/mock/sat.png", link: "/sat" },
  { name: "GMAT", src: "./image/mock/gmat.png", link: "/gmat" },
  { name: "GRE", src: "./image/mock/ets-gre.png", link: "/gre" },
];

const responsiveTests = {
  desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
  tablet: { breakpoint: { max: 1024, min: 640 }, items: 2 },
  mobile: { breakpoint: { max: 640, min: 0 }, items: 1 },
};

const MockTestsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
       <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
          
        `}
      </style>

      {/* Header */}
      <div className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center">
        <h2 className="text-4xl mt-10 font-bold text-indigo-700 mb-4">
          English Proficiency Tests
        </h2>
        <p className="text-gray-600 mb-10 mt-5 max-w-2xl mx-auto">
          Explore key exams required for study, work, and immigration abroad.
        </p>

        {/* Carousel */}
        <Carousel
          responsive={responsiveTests}
          infinite
          autoPlay
          autoPlaySpeed={3000}
          keyBoardControl
          arrows
          showDots={false}
          containerClass="carousel-container"
          itemClass="px-4"
        >
          {mockTests.map((test, index) => (
            <Link
              key={index}
              to={test.link}
              className="group block bg-gray-200 mt-10 text-center rounded-xl shadow hover:shadow-lg transition-all duration-200 p-6 border border-gray-200 hover:border-indigo-500"
            >
              <img
                src={test.src}
                alt={test.name}
                className="h-40 w-full object-contain rounded transition-transform duration-300 group-hover:scale-105"
              />
              <h5 className="mt-4 text-xl font-semibold text-gray-800 group-hover:text-indigo-600">
                {test.name}
              </h5>
            </Link>
          ))}
        </Carousel>
      </div>

      {/* CTA Section */}
      <div className="text-center mt-12 mb-16">
        <a
          href="/contact-us"
          className="inline-block bg-blue-600 text-white px-8 py-4 font-semibold text-lg rounded-md hover:bg-blue-700 transition-colors duration-300"
        >
          Take a MOCK Test Now
        </a>
      </div>
    </div>
  );
};

export default MockTestsPage;
